import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// Modules
import auth from './auth'
import dashboard from './dashboard.module'
import shipping from './shipping.module'
import paymentMethod from './paymentMethod.module'
import address from './address.module'
import platform from './platform.module'
import meli from './meli.module'
import user from './user.module'
import faqs from './faqs.module'

const store = new Vuex.Store({
  modules: {
    auth,
    dashboard,
    shipping,
    paymentMethod,
    user,
    address,
    platform,
    meli,
    faqs
  }
})

export default store
